import {ALL_PERIODS} from '../../../periods';

/**
 * Los períodos que el cliente puede elegir sobre un Informe.
 *
 * Espejo de `ALLOWED_PERIODS` del backend (`reports/services/period_catalog.py`): cuatro
 * períodos del catálogo dependen de una línea de control o de otro período de referencia y el
 * motor los rechaza con 422, y «Mismo período del año anterior» sólo vale como COMPARACIÓN.
 * El picker los ofrecía igual y elegirlos dejaba al cliente con «No pudimos cargar este
 * informe» (QA FE-10).
 */
export const INFORME_EXCLUDED_PERIODS = [
    'THIS_PERIOD',
    'THIS_PERIOD_TILL_YESTERDAY',
    '7_DAYS_BEFORE',
    '14_DAYS_BEFORE',
    'SAME_PERIOD_LAST_YEAR',
];

export const INFORME_PORTAL_PERIODS = ALL_PERIODS.filter((p) => !INFORME_EXCLUDED_PERIODS.includes(p));
